import { z } from 'zod';

export const ClientUsage = z.object({
  calls: z.number().int().min(0),
  costUsd: z.number().min(0),
});
export type ClientUsage = z.infer<typeof ClientUsage>;

export const AnthropicUsage = z.object({
  inputTokens: z.number().int().min(0),
  cachedInputTokens: z.number().int().min(0),
  outputTokens: z.number().int().min(0),
  costUsd: z.number().min(0),
});
export type AnthropicUsage = z.infer<typeof AnthropicUsage>;

export const ApiUsageDoc = z.object({
  dataForSeoCalls: z.number().int().min(0),
  dataForSeoCostUsd: z.number().min(0),
  anthropic: AnthropicUsage,
  byClient: z.record(ClientUsage),
});
export type ApiUsageDoc = z.infer<typeof ApiUsageDoc>;
